import React, { useState } from 'react';
import { Box } from '@mui/material';
import { FormaliteDocument } from '@europrocurement/l2d-domain';
import { ModalConfirm, useModal } from '@europrocurement/flexy-components';
import { useNavigate } from 'react-router-dom';
import DocumentTypeCard from './DocumentTypeCard';
import DocumentTypeEditModal from './DocumentTypeEditModal';
import useDocumentTypeFormHandler from '../../hooks/useDocumentTypeFormHandler';
import { DOCUMENT_TYPE_LIST } from '../../constants/paths';

type DocumentTypeMainTabProps = {
    documentType: FormaliteDocument;
};

const DocumentTypeMainTab: React.FunctionComponent<DocumentTypeMainTabProps> = function (props) {
    const { documentType } = props;
    const [editModalOpen, setEditModalOpen] = useState(false);
    const { modalActions } = useModal();
    const { handleDeleteForm } = useDocumentTypeFormHandler();
    const navigate = useNavigate();

    const onConfirmDelete = () => {
        handleDeleteForm(documentType).then(() => {
            navigate(DOCUMENT_TYPE_LIST);
        });
    };

    const handleDelete = () => {
        modalActions.call(
            <ModalConfirm
                onConfirm={onConfirmDelete}
                message="Êtes-vous sûr de vouloir supprimer ce type de document ?"
            />,
        );
    };

    return (
        <>
            <Box>
                <DocumentTypeCard
                    documentType={documentType}
                    handleEditMainInformation={() => setEditModalOpen(true)}
                    handleDelete={handleDelete}
                />
            </Box>
            <DocumentTypeEditModal
                documentType={documentType}
                isOpen={editModalOpen}
                onClose={() => setEditModalOpen(false)}
            />
        </>
    );
};

export default DocumentTypeMainTab;
